<form #validateFlyoutForm [formGroup]="quickOrderForm" (keyup)="isInValidQuantity()">
  <formly-form [model]="model" [fields]="fields" [options]="options" [form]="quickOrderForm" />

  <div class="quickorder-btn d-flex m-2">
    <div class="col-8 pl-0">
      <button
        type="submit"
        (click)="onSubmit('AddMoreParts')"
        class="btn btn-primary"
        [disabled]="quickOrderForm.invalid || quickOrderForm.pristine || inValidQuantity"
        data-testing-id="addMoreParts"
      >
        {{ 'dias.quickorder.flyout.add.more.part.text' | translate }}
      </button>
    </div>

    <div class="col-4 pl-0">
      <button
        type="submit"
        (click)="onSubmit('AddProducts')"
        class="btn btn-primary"
        [disabled]="quickOrderForm.invalid || quickOrderForm.pristine || inValidQuantity"
        data-testing-id="submit"
      >
        {{ 'dias.quickorder.flyout.submit.text' | translate }}
      </button>
    </div>
  </div>
</form>
